<template>
  <section class="hero">
    <div class="hero__content">
      <div class="hero__text">
        <h1 class="hero__headline">
          <p>Is Workers' Comp</p>
          <p>slowing you down?</p>
        </h1>
        <div class="hero__subheadline">
          <p>Don't waste time with long applications, tricky calculations and never ending follow ups for low margins. Pass your Workers' Comp requests to us, we'll take care of them quickly and cleanly and share the commission with you.</p>
        </div>
      </div>
      <div class="hero__illustration">
        <img src="/assets/hero-maze.png" alt="Maze illustration showing complexity of Workers' Comp" class="hero-image" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Hero'
}
</script>

<style scoped>
.hero {
  background: #F8FAFC;
  padding: 80px 64px 0px 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: visible;
}

.hero__content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;
  max-width: 1200px;
  width: 100%;
  position: relative;
}

.hero__text {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.hero__headline {
  font-family: 'Fraunces', serif;
  font-weight: 700;
  font-size: 64px;
  line-height: 1;
  color: #0077ff;
  letter-spacing: -1.92px;
  margin: 0;
  font-variation-settings: 'SOFT' 0, 'WONK' 1;
}

.hero__headline p {
  margin: 0;
}

.hero__subheadline {
  font-family: 'Fraunces', serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.4;
  color: #1e1e1e;
  font-variation-settings: 'SOFT' 0, 'WONK' 1;
}

.hero__subheadline p {
  margin: 0;
}

.hero__illustration {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  z-index: 15;
}

.hero-image {
  width: 100%;
  max-width: 714px;
  height: auto;
  object-fit: contain;
  object-position: center;
  position: relative;
  top: 80px;
  z-index: 15;
}

@media (max-width: 1024px) {
  .hero {
    padding: 80px 32px;
  }
  
  .hero__content {
    grid-template-columns: 1fr;
    gap: 32px;
    text-align: center;
  }
  
  .hero__text {
    max-width: 543px;
    margin: 0 auto;
  }
  
  .hero__headline {
    font-size: 48px;
  }
  
  .hero-image {
    width: 100%;
    max-width: 500px;
  }
}

@media (max-width: 768px) {
  .hero {
    padding: 64px 16px;
  }
  
  .hero__headline {
    font-size: 36px;
    letter-spacing: -1px;
  }
  
  .hero__subheadline {
    font-size: 18px;
  }
}
</style>
